export default [
  {
    path: "/",
    component: () => import("@/pages/landing-page/HomePage.vue"),
    meta: { title: "Home" },
  },
  // {
  //   path: "*",
  //   component: () => import("@/pages/landing-page/HomePage.vue"),
  //   meta: { title: "Home" },
  // },
  {
    path: "/dashboard/",
    component: () => import("@/pages/dashboard/dashboard-page.vue"),
    meta: { title: "Dashboard" },
  },
  {
    path: "/forbidden/",
    component: () => import("@/pages/Forbidden.vue"),
    meta: { title: "Akses Ditolak" },
  },
  {
    path: "/docs-api",
    component: () => import("@/pages/OpenApiDocs.vue"),
    meta: {
      title: "Dokumentasi Open API",
      public: true,
      publicLayout: true,
    },
  },
  {
    path: "*",
    component: () => import("@/pages/NotFound.vue"),
  },
];
